// src/components/SplashScreen.jsx
import React, { useEffect, useState } from "react";

// Paths to your logos
const splashLogo = new URL("../../logos/circle_cropped_Logo1.png", import.meta.url).href;
const smallLogo = new URL("../../logos/croped_Logo1_150x150.png", import.meta.url).href;

export default function SplashScreen({ onComplete }) {
  const [closing, setClosing] = useState(false);
  
  useEffect(() => {
    // 1. Wait before starting animation (1.4s)
    const t1 = setTimeout(() => {
      setClosing(true);

      // 2. Wait for animation to finish (650ms), then unmount
      const t2 = setTimeout(() => {
        onComplete();
      }, 650);

      return () => clearTimeout(t2);
    }, 1400);

    return () => clearTimeout(t1);
  }, [onComplete]);

  return (
    <div
      className={`
        fixed inset-0 z-[9999] flex items-center justify-center
        transition-colors duration-[650ms] ease-in-out
        ${closing ? "pointer-events-none bg-transparent" : "bg-[#f7eccc]"}
      `}
    >
      <img
        src={splashLogo}
        alt="GnosisFT Logo"
        onError={(e) => (e.currentTarget.src = smallLogo)}
        className={`
          max-w-[80vw] max-h-[70vh] drop-shadow-2xl
          transition-all duration-[650ms] ease-in-out
          ${closing 
            ? "-translate-x-[45vw] -translate-y-[45vh] scale-[0.12] opacity-90" 
            : "scale-100 opacity-100"
          }
        `}
      />
    </div>
  );
}